<section class="container accessibility">
    <div class="headline">
        <h1 class="title">accessibility statement</h1>
        <img src="../../../assets/accessibility/accessibility.png" alt="accessibility" class="icons">
    </div>

    <div class="content">
        <p>The Rehabilitation Act of 1973 prohibits discrimination on the basis of disability in programs
            conducted by Federal agencies, in programs receiving Federal financial assistance, in Federal
            employment, and in the employment practices of Federal contractors.</p>
        <p>Section 504 states that "no qualified individual with a disability in the United States shall be
            excluded from, denied the benefits of, or be subjected to discrimination under" any program or
            activity that either receives Federal financial assistance or is conducted by any Executive agency.
        </p>
        <p>Section 508 now establishes requirements for electronic and information technology developed,
            maintained, procured, or used by the Federal government. Section 508 requires Federal electronic and
            information technology to be accessible to people with disabilities, including employees and members
            of the public.</p>
        <p>In December 2000 the Federal Access Board issued final standards for electronic and information
            technology under Section 508 of the Rehabilitation Act. These were adopted and published in the
            Federal Registrar in April 2001 with enforcement to begin June 21, 2001.</p>
        <p>While these standards currently apply to federal government, The WorldERP, Inc. complies with
            these accessibility guidelines and apply these principles when designing and creating all web pages.
        </p>
        <p>While the core structure of The WorldERP, Inc. Site already adheres to Section 508 Compliance,
            there are ongoing progressive measures in place to assure complete compliance throughout The
            WorldERP, Inc. Internet information structure and Web-based enterprise.</p>
        <p class="subtitle">Questions and Suggestions </p>
        <p>If you have questions or suggestions, please complete a feedback form
            or you can contact us at:</p>
        <p><b>By mail: <br>
            Accessibility <br>
            c/o The WorldERP,  Inc.<br>
            1621 Central Ave.<br>
            Cheyenne, WY 82001</b></p>
        <p><b>Or by email: <span class="link email">moc.predlrow@lagel</span></b></p>
    </div>
</section>
